import { combineReducers } from 'redux';

import newsletterReducer from './NewsletterReducer';

// Combine Reducers
let reducers = combineReducers({
	newsletterState: newsletterReducer
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js